<div *ngIf="redemption==null">
  <!--<h2 mat-dialog-title>POST A REVIEW</h2>-->
  <mat-dialog-content class="mat-typography">

    <section id="post_review_section"></section>

    <form action="POST" [formGroup]="redeemForm">
      <div class="review-r-d-input-fields pt-4">
        <div class="container">
          <div class="pros-area mt-4">

            <p>Scan QR to choose a shop</p>
            <div class="pros-single-item-content d-flex align-items-end">
              <zxing-scanner *ngIf="scannedCode==null"
                             [formats]="allowedFormats" (scanSuccess)="onScanSuccess($event)"
                             (scanFailure)="onScanFailure($event)"></zxing-scanner>

              <div class="pros-single-item-content d-flex align-items-end" *ngIf="scannedCode!=null">
                <div class="fields">
                  <label for="selected-vendor" class="form-label">Selected Shop</label>
                  <input type="text" id="selected-vendor" class="form-control"
                         required="required" readonly [value]="scannedCode.name">
                </div>
              </div>
            </div>

            <!--            <div class="pros-single-item-content d-flex align-items-end">-->
            <!--              <div class="fields">-->
            <!--                <mat-form-field class="example-full-width" appearance="fill">-->
            <!--                  <input type="text"-->
            <!--                         placeholder="Pick one"-->
            <!--                         aria-label="Number"-->
            <!--                         matInput-->
            <!--                         formControlName="vendor"-->
            <!--                         (input)="searchVendors()"-->
            <!--                         [matAutocomplete]="auto">-->
            <!--                  <mat-autocomplete #auto="matAutocomplete">-->
            <!--                    <mat-option *ngFor="let vendor of getVendors() | async" [value]="vendor.id">-->
            <!--                      {{vendor.name}}-->
            <!--                    </mat-option>-->
            <!--                  </mat-autocomplete>-->
            <!--                </mat-form-field>-->
            <!--              </div>-->
            <!--            </div>-->
            <!--            <div class="text-warning" *ngIf="isInvalidInput(redeemForm.controls['points'])">-->
            <!--              <span>Please select a vendor</span>-->
            <!--            </div>-->

          </div>

          <div *ngIf="scannedCode!=null">
            <div class="cons-area mt-4">
              <h2>Enter amount</h2>
              <div class="pros-single-item-content d-flex align-items-end">
                <div class="fields">
                  <label for="points" class="form-label">Points</label>
                  <input type="number" id="points" class="form-control"
                         placeholder="Enter the amount you want to redeem"
                         formControlName="points" required="required"
                         min="3">
                </div>
              </div>
              <div class="text-warning" *ngIf="isInvalidInput(redeemForm.controls['points'])">
                <span>Minimum 10 to maximum 1000 can be redeemed.</span>
              </div>

            </div>

            <div class="post-btn d-flex justify-content-end mt-4">
              <button [disabled]="redeemForm.invalid" (click)="redeem()" type="submit" class="boxed-btn"><i
                class="flaticon-plus"></i> REDEEM
              </button>
            </div>
          </div>

        </div>
      </div>

    </form>

  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close="">CANCEL</button>
  </mat-dialog-actions>
</div>


<div *ngIf="redemption!=null">
  <h2 mat-dialog-title>Congratulations! Pay TK{{redemption.discount_amount}} less.</h2>
  <mat-dialog-content class="mat-typography">
    You have successfully redeemed {{redemption.points}} points.
    You got TK{{redemption.discount_amount}} discount from Astha loyalty points.
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close="">CLOSE</button>
  </mat-dialog-actions>
</div>
